import React, { useEffect, useState } from 'react';
import { Container, Image, Button } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import { NavLink, useLocation } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PrivateHeader from './PrivateHeader';
import useAuthStore from 'store/auth';
import Sidebar from 'components/Sidebar';
import './styles.scss';
import { logLogoClick } from 'services';

const Header: React.FC = () => {
	const { token }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { translate } = useTranslate();
	const location = useLocation();

	const [showModal, setShowModal] = useState(false);
	const handleShow = () => {
		setShowModal(true);
	};
	const handleModalClose = () => {
		setShowModal(!showModal);
	};

	useEffect(() => {
		const launcherElement = document.getElementById('launcher');
		if (launcherElement) {
			if (showModal) {
				launcherElement.classList.add('d-none');
			} else {
				launcherElement.classList.remove('d-none');
			}
		}
	}, [showModal]);

	return (
		<Navbar collapseOnSelect sticky="top" className={`bg-white ${!token ? 'nav-mobile' : ''}`}>
			<Container fluid className="position-relative">
				{token && (
					<Button
						variant="primary"
						onClick={() => handleShow()}
						className="sidebar-btn d-xl-none bg-transparent border-0 p-0"
					>
						<i className="ri-bar-chart-horizontal-line"></i>
					</Button>
				)}
				{showModal && <Sidebar showModal={showModal} onClose={handleModalClose} />}

				<NavLink
					to="/"
					className="navbar-brand text-center p-0 text-decoration-none lh-1"
					onClick={() => logLogoClick(location.pathname)}
				>
					<Image src={IMAGE_PATHS.JobstasLogoHeader} alt="brand-logo" loading="lazy" />
					{/* <h5 className="mb-0 fw-normal">{translate('Header.logoTitle')}</h5> */}
				</NavLink>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" className="border-0" />
				{token ? <PrivateHeader /> : <PublicHeader />}
			</Container>
		</Navbar>
	);
};

export default Header;
